
import axios from "axios";
import { LIMITE_REGISTROS_PESQUISA } from '../../../static/parametros/parametros.js'

export default {
  namespaced: true,
  state: {
      lista: [],
      nome: null,
      id: null,
      cpf: null,
      perPage: 100,
      registroSelecionadoId: null,
      paginaAtual: 1,
  },
  getters: {
    LISTA: state => {
        return state.lista
    },
    ID: state => {
        return state.id
    },
    NOME: state => {
        return state.nome
    },
    PER_PAGE: state => { 
        return state.perPage
    },
    REGISTRO_SELECIONADO_ID: state => {
        return state.registroSelecionadoId
    },
    PAGINA_ATUAL: state => {
        return state.paginaAtual
    }
  },
  /** MUTACOES SAO SINCRONAS - SEMELHANTES AO COMPUTED */
  mutations: {
      SET_LISTA: (state, payload) => {
          state.lista = payload
      },
      SET_ID: (state, payload) => {
          state.id = payload
      },
      SET_NOME: (state, payload) => {
          state.nome = payload
      },
      SET_PER_PAGE: (state, payload) => {
          state.perPage = payload
      },
      SET_REGISTRO_SELECIONADO_ID: (state, payload) => {
          state.registroSelecionadoId = payload
      },
      SET_PAGINA_ATUAL: (state, payload) => {
          state.paginaAtual = payload
      },
      SET_LIMPAR: (state, payload) => {
        lista = [],
        registroSelecionadoId = null
        paginaAtual = 1
      },
      SET_LIMPAR_APENAS_FILTRO: (state, payload) => {
          state.filtroAvancado = false,
          state.lista = [],
          state.paginaAtual = 1
      },
  },
  /** ACTOINS SAO ASSINCRONOS */
  actions: {
    GERAR_LISTA: ({ commit, getters}, { skipConfirmation = false } = {}) => {
        return new Promise((resolve, reject) => {
          let id = (getters.ID !== null ? getters.ID : '')
          let nome = (getters.NOME !== null ? getters.NOME : '')
          
          // Detecta se NOME contém apenas números inteiros (código do vendedor)
          if (nome && nome.trim() && /^\d+$/.test(nome.trim())) {
            // Se for apenas números, usa como ID em vez de nome
            id = nome.trim()
            nome = ''
          }
          
          let uri = `api/protected/vendedor/pesquisar?idPesquisa=${id}&nomePesquisa=${nome}`
          axios
            .get(uri)
            .then(({ data, status }) => {
              // Verifica se o resultado tem mais de LIMITE_REGISTROS_PESQUISA registros e precisa de confirmação
              if (!skipConfirmation && data && data.length > LIMITE_REGISTROS_PESQUISA) {
                // Retorna os dados sem comitar, indicando que precisa de confirmação
                resolve({ 
                  data, 
                  status,
                  needsConfirmation: true,
                  count: data.length
                });
                return
              }
              
              // Carrega os dados normalmente
              commit("SET_LISTA", data);
              if (status === 200 || status === 201) {
                resolve({ data, status, needsConfirmation: false });
              }
            })
            .catch(error => {
              reject(error);
            });
        });
      },
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modulos/vendedor-store.js